module.exports = __webpack_public_path__ + "static/media/unibestMv3.dbe8ec7c.png";